import React from 'react';
import { getInstance as getBootstrap } from 'utils/bootstrap';

const bootstrap = getBootstrap();
const bootstrapFonts = bootstrap.get('availableFonts');

export const AvailableFontsContext = React.createContext(bootstrapFonts);

export function withAvailableFonts(Component) {
    return function ComponentWithFonts(props) {
        return (
            <AvailableFontsContext.Consumer>
                {(availableFonts) => <Component {...props} availableFonts={availableFonts} />}
            </AvailableFontsContext.Consumer>
        );
    };
}
